import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useLeads } from '../hooks/useLeads';
import { Col, Container, Row } from 'react-bootstrap';

function LeadOverview({leadData}) {
  const { leadId } = useParams();
  const userId = window.localStorage.getItem('projectUserUID');
  const userRole = window.localStorage.getItem('projectUserRole');
  


const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-IN');
};

  return (
    <Container>
      <Row>
           
        <Col className='p-3'>
           <div>

       <div>

          <p><strong>Client Name:</strong> {leadData.full_name}</p>
          <p><strong>Mobile Number:</strong> {leadData.mobile_number}</p>
          <p><strong>Email Address:</strong> {leadData.email_address}</p>
          <p><strong>Configuration:</strong> {leadData.configuration}</p>
          <p><strong>Property Type:</strong> {leadData.propertyType}</p>
          <p><strong>Property Name:</strong> {leadData.propertyName}</p>
          <p><strong>Address:</strong> {leadData.address}</p>
          <p><strong>City:</strong> {leadData.city}</p>
          <p><strong>Requirement Type:</strong> {leadData.requirementType}</p>
          <p><strong>Service Type:</strong> {leadData.serviceType}</p>



        </div>

    </div>
        </Col>
        <Col className='p-3'>
           <div>

      
      {/* <pre>{JSON.stringify(leadData, null, 2)}</pre> */}
      <div>

          <p><strong>Lead Acquisition Date:</strong> {leadData.leadAcquisitionDate}</p>
          <p><strong>Meeting Date:</strong> {leadData.meeting_date}</p>
          <p><strong>Sales Rep:</strong> {leadData.sales_rep}</p>
          <p><strong>Pre-Sales Rep:</strong> {leadData.presales_name}</p>
          <p><strong>Source:</strong> {leadData.source}</p>
          <p><strong>Channel:</strong> {leadData.channel}</p>
          <p><strong>Medium:</strong> {leadData.medium}</p>
          <p><strong>Campaign:</strong> {leadData.campaign}</p>
          <p><strong>Possession:</strong>  {leadData.possession}</p>
          <p><strong>Move In Date:</strong>  {leadData.move_in_date}</p>
          <p><strong>Budget:</strong> {leadData.budget}</p>

        </div>
    </div>
        </Col>
      </Row>
    </Container>
 
  );
}

export default LeadOverview;